import React from 'react'
import SiteGrid from "../ui/SiteGrid"
import SquareGrid from "../ui/SquareGrid"
import { servicesData } from "app/data/servicesData"
import IconContainer from "../ui/IconContainer"
import AppButton from "../ui/AppButton"

export default function Services() {

  const servicesRender = servicesData?.map((service, index) => {
    return <ServiceCard
      key={index}
      {...service}
    />
  })

  return (
    <div className="services-section home-section">
      <SiteGrid className="services-flex">
        <div className="text-container">
          <h6 className="title">Our Services</h6>
          <h2 className="title">Comprehensive Care for Your Health Needs</h2>
          <p>
            Our services include general medicine, pediatrics, women's health,
            dermatology, and mental health. We also offer a range of diagnostic
            and screening tests, as well as vaccination services. Whatever your
            healthcare needs may be, we're here to provide you with personalized,
            comprehensive care that puts your health first.
          </p>
          <AppButton
            label="Explore Services"
            buttonType="outlineBtn animate"
            url="/services/general-medicine"
          />
        </div>
        <div className="cards-container">
          {servicesRender}
        </div>
      </SiteGrid>
      <div className="circle-1 circle" />
      <div className="circle-2 circle" />
      <SquareGrid
        className="square-grid-1"
        color="var(--primary)"
      />
      <SquareGrid
        className="square-grid-2"
        number={25}
        columns={5}
      />
    </div>
  )
}

export const ServiceCard = ({ icon, title, text }) => {
  return (
    <div className="service-card">
      <IconContainer
        dimensions={50}
        iconSize={18}
        iconColor="var(--primary)"
        bgColor="#fff"
        icon={icon}
      />
      <h4 className="title">{title}</h4>
      <p className="text">{text}</p>
      <div className="shape-container">
        <div className="circle" />
      </div>
    </div>
  )
}